import { Calendar, dateFnsLocalizer } from 'react-big-calendar'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import getDay from 'date-fns/getDay'
import ptBR from 'date-fns/locale/pt-BR'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { Booking } from '@/types'
import { useNavigate } from 'react-router-dom'

const locales = {
    'pt-BR': ptBR,
}

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
})

interface CalendarViewProps {
    bookings: Booking[]
}

export default function CalendarView({ bookings }: CalendarViewProps) {
    const navigate = useNavigate()

    const events = bookings.map(booking => ({
        id: booking.id,
        title: (booking as any).spaceName || 'Reserva',
        start: booking.start?.toDate?.() || new Date(booking.start),
        end: booking.end?.toDate?.() || new Date(booking.end),
        resource: booking,
    }))

    const handleSelectEvent = (event: any) => {
        navigate(`/bookings/${event.id}`)
    }

    const eventStyleGetter = (event: any) => {
        const status = event.resource.status
        let backgroundColor = '#001c28' // Default

        if (status === 'CONFIRMED') backgroundColor = '#10b981'
        if (status === 'PENDING_APPROVAL') backgroundColor = '#3b82f6'
        if (status === 'PENDING_PAYMENT') backgroundColor = '#f59e0b'
        if (status === 'CANCELED') backgroundColor = '#ef4444'

        return {
            style: {
                backgroundColor,
                borderRadius: '8px',
                opacity: 0.8,
                color: 'white',
                border: 'none',
                display: 'block',
                fontSize: '12px',
                fontWeight: 'bold',
                padding: '4px 8px'
            }
        }
    }

    return (
        <div className="glass-card p-6 h-[700px] animate-in fade-in duration-500">
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: '100%' }}
                onSelectEvent={handleSelectEvent}
                eventPropGetter={eventStyleGetter}
                messages={{
                    next: "Próximo",
                    previous: "Anterior",
                    today: "Hoje",
                    month: "Mês",
                    week: "Semana",
                    day: "Dia",
                    agenda: "Agenda",
                    date: "Data",
                    time: "Hora",
                    event: "Evento",
                    noEventsInRange: "Nenhuma reserva neste período.",
                    showMore: (total: number) => `+ Ver mais (${total})`
                }}
                culture="pt-BR"
            />
        </div>
    )
}
